export default {
    // to standardize all decimal format
    methods: {
        costFormattedNumber(value) {
            // return numeral(value).format('0,0.0000000');
            return numeral(value).format('0,0.0000');
        },

        formattedNumber(value) {
            return numeral(value).format('0,0.0000');
        },

        totalFormattedNumber(value) {
            return numeral(value).format('0,0.00');
        },

        noDecimalNumber(value) {
            return numeral(value).format('0,0');
        },

        costTruncateNumber(value) {
            return value.toFixed(7).slice(0, -3);
        },

        noDecimalTruncateNumber(value) {
            return value.toFixed(2);
        },

        formattedQuantity(value) {
            return numeral(value).format('0,0');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/format-mixin.js